import { LabelComponent } from "../labels/labelComponents"
import { Order } from "../../pages/SalesPage/SalesPageInterface"
import { formatPartialOrderHash } from "../../utils/formatters"
import { Link, useLocation } from "react-router-dom"
import { ArrowLeft } from "lucide-react"
import { useContext } from "react"
import { OrderDetailsContext } from "../../context/OrderDetailContext"
import { PaidState } from "../../types/order/paidState"
import { LogisticState } from "../../types/order/logisticState"
import { dictionary } from "../../utils/dictionary"
import { useAuth } from "../../context/AuthContext"

export interface TopNavBarComponentProps {
    order: Order | null
}

export const TopNavBarComponent = () => {
    const context = useContext(OrderDetailsContext);
    const { language } = useAuth();
    if (!context || !context.orderDetails) return null;
    
    const location = useLocation();
    
    const { orderDetails: order } = context;
  
    return (
      <div className="bg-white p-6 flex flex-row gap-4 items-center">
        <Link to={`/orders${location.search}`} className="flex items-center text-gray-600 hover:text-gray-900 mr-4">
          <ArrowLeft size={20} className="mr-2" />
        </Link>
        <div className="flex flex-row gap-2">
          <p>
            {dictionary["order-details"][language]} <span className="pl-2">{"  "}</span>#
            {formatPartialOrderHash(order?.hash_id?.toString() || "")}
          </p>
          {order.payment_state ? (
            order.payment_state === PaidState.PAID ? (
              <div className="flex items-center">
                <span className="flex items-center px-3 py-1 text-sm rounded-full bg-green-100 text-green-800">
                  <span className="w-2 h-2 mr-2 bg-green-500 rounded-full"></span>
                  {dictionary["paid-state"][language]}
                </span>
              </div>
            ) : (
              <div className="flex items-center">
                <span className="flex items-center px-3 py-1 text-sm rounded-full bg-red-100 text-red-800">
                  <span className="w-2 h-2 mr-2 bg-red-500 rounded-full"></span>
                  {order.payment_state === LogisticState.CREATED
                    ? dictionary["unpaid-state"][language]
                    : dictionary["pending-state"][language]}
                </span>
              </div>
            )
          ) : null}
          <LabelComponent
            text={order?.logistic_state === LogisticState.IN_PROGRESS ? dictionary["fulfilled-state"][language] : dictionary["unfulfilled-state"][language]}
            bg={order?.logistic_state === LogisticState.IN_PROGRESS ? "bg-blue-100" : "bg-yellow-100"}
            color={order?.logistic_state === LogisticState.IN_PROGRESS ? "text-blue-800" : "text-yellow-800"}
          />
          <LabelComponent text={dictionary["priority"][language]} bg="bg-violet-100" color="text-violet-800" />
        </div>
      </div>
    );
  };
